import { useState, useRef, useMemo } from 'react';
import type { Player, Product, BookingItem, Booking } from '../types';

export const useAdminBookingModalState = (schedule: any, activeBooking: any, players: Player[]) => {
  // --- FORMULARIO DE ASIGNACIÓN MANUAL ---
  const [formResetKey, setFormResetKey] = useState(0);
  const manualPlayerName = useRef('');
  const manualPlayerPhone = useRef('');
  const [searchPlayerQuery, setSearchPlayerQuery] = useState('');
  const [selectedPlayer, setSelectedPlayer] = useState<Player | null>(null);
  const [showPlayerDropdown, setShowPlayerDropdown] = useState(false);
  const manualNotes = useRef('');
  const [manualIsFixed, setManualIsFixed] = useState(false);
  const [manualPrice, setManualPrice] = useState(12000);

  const currentDiscountPercent = useMemo(() => {
    const basePrice = schedule?.pricePerSlot || 12000;
    const currentPrice = activeBooking ? (activeBooking.price ?? basePrice) : manualPrice;
    return Math.max(0, Math.round(((basePrice - currentPrice) / basePrice) * 100));
  }, [activeBooking, manualPrice, schedule?.pricePerSlot]);

  // --- PRODUCTOS Y COMPRAS ---
  const [availableProducts, setAvailableProducts] = useState<Product[]>([]);
  const [bookingItems, setBookingItems] = useState<BookingItem[]>([]);
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const [itemQuantity, setItemQuantity] = useState(1);
  const [itemNote, setItemNote] = useState('');
  const [showItemDropdown, setShowItemDropdown] = useState(false);
  const [showQuickItemModal, setShowQuickItemModal] = useState(false);
  const [quickItemName, setQuickItemName] = useState('');
  const [quickItemPrice, setQuickItemPrice] = useState<number | ''>('');
  const [quickItemQuantity, setQuickItemQuantity] = useState<number>(1);
  const [showChargeConfirmModal, setShowChargeConfirmModal] = useState(false);
  const [chargePaymentCash, setChargePaymentCash] = useState<string>('');
  const [chargePaymentTransfer, setChargePaymentTransfer] = useState<string>('');
  const [chargePaymentTotal, setChargePaymentTotal] = useState<string>('');

  // --- POPUP EMERGENTE DE TURNO FIJO ---
  const [confirmFixedPopup, setConfirmFixedPopup] = useState<{
    booking: Booking;
    targetIsFixed: boolean;
  } | null>(null);
  const [showManualFixedConfirm, setShowManualFixedConfirm] = useState(false);
  const [isEditingNotes, setIsEditingNotes] = useState(false);
  const bookingNotesEditRef = useRef('');
  const [showCancelConfirmPopup, setShowCancelConfirmPopup] = useState(false);
  const [showCobradoToast, setShowCobradoToast] = useState(false);

  // --- ESTADO DE FILTRADO PARA BUSCADOR ---
  const filteredPlayers = searchPlayerQuery.trim() === ''
    ? []
    : players.filter(p => p.name.toLowerCase().includes(searchPlayerQuery.toLowerCase()));

  // --- TABS DEL MODAL ---
  const [modalActiveTab, setModalActiveTab] = useState<'info' | 'payments' | 'actions' | 'tools'>('info');

  // --- ESTADOS DE EDICIÓN RÁPIDA ---
  const [isEditingPrice, setIsEditingPrice] = useState(false);
  const [tempPrice, setTempPrice] = useState('');
  const [isEditingDiscount, setIsEditingDiscount] = useState(false);
  const [tempDiscount, setTempDiscount] = useState('');
  const [tempCourtSelect, setTempCourtSelect] = useState<number>(1);
  const [tempItemSelect, setTempItemSelect] = useState<Record<string, number>>({});

  // --- ESTADOS DE CONFIRMACIÓN DE ASISTENCIA ---
  const [showConfirmAttendancePopup, setShowConfirmAttendancePopup] = useState(false);

  // --- PROMOCIONES ---
  const [promoDiscount, setPromoDiscount] = useState<number | ''>('');
  const [promoDrink, setPromoDrink] = useState(false);
  const [promoBalls, setPromoBalls] = useState(false);
  const [promoWinnerPrize, setPromoWinnerPrize] = useState(false);

  return {
    formResetKey, setFormResetKey,
    manualPlayerName,
    manualPlayerPhone,
    searchPlayerQuery, setSearchPlayerQuery,
    selectedPlayer, setSelectedPlayer,
    showPlayerDropdown, setShowPlayerDropdown,
    manualNotes,
    manualIsFixed, setManualIsFixed,
    manualPrice, setManualPrice,
    currentDiscountPercent,
    availableProducts, setAvailableProducts,
    bookingItems, setBookingItems,
    selectedProduct, setSelectedProduct,
    itemQuantity, setItemQuantity,
    itemNote, setItemNote,
    showItemDropdown, setShowItemDropdown,
    showQuickItemModal, setShowQuickItemModal,
    quickItemName, setQuickItemName,
    quickItemPrice, setQuickItemPrice,
    quickItemQuantity, setQuickItemQuantity,
    showChargeConfirmModal, setShowChargeConfirmModal,
    chargePaymentCash, setChargePaymentCash,
    chargePaymentTransfer, setChargePaymentTransfer,
    chargePaymentTotal, setChargePaymentTotal,
    confirmFixedPopup, setConfirmFixedPopup,
    showManualFixedConfirm, setShowManualFixedConfirm,
    isEditingNotes, setIsEditingNotes,
    bookingNotesEditRef,
    showCancelConfirmPopup, setShowCancelConfirmPopup,
    showCobradoToast, setShowCobradoToast,
    filteredPlayers,
    modalActiveTab, setModalActiveTab,
    isEditingPrice, setIsEditingPrice,
    tempPrice, setTempPrice,
    isEditingDiscount, setIsEditingDiscount,
    tempDiscount, setTempDiscount,
    tempCourtSelect, setTempCourtSelect,
    tempItemSelect, setTempItemSelect,
    showConfirmAttendancePopup, setShowConfirmAttendancePopup,
    promoDiscount, setPromoDiscount,
    promoDrink, setPromoDrink,
    promoBalls, setPromoBalls,
    promoWinnerPrize, setPromoWinnerPrize
  };
};
